import React, { forwardRef, memo } from 'react';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import classNames from 'classnames';
import { FormHelperText } from '@mui/material';
import { StyledUiSelect } from './UiSelect.styles';

const UiSelect = forwardRef(
  ({ name, control, children, className = '', ...rest }, ref) => {
    if (control)
      return (
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState: { error } }) => {
            return (
              <StyledUiSelect
                className={classNames('ui-select', error && 'error')}
              >
                <Select
                  name={name}
                  ref={ref}
                  className={className}
                  fullWidth
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        padding: '0',
                        direction: (theme) => theme.direction,
                        '& .MuiList-root': {
                          '& .MuiMenuItem-root': {
                            padding: '16px !important',
                            lineHeight: '20px !important',
                            fontFamily: 'inherit !important',
                            fontSize: '0.75rem !important',
                            '&:hover': {
                              color: '#222222 !important',
                              borderRadius: '6px !important',
                              textDecoration: 'none',
                              backgroundColor: '#aadbdd !important',
                            },
                          },
                        },
                      },
                    },
                  }}
                  {...field}
                  {...rest}
                >
                  {children}
                </Select>
                {error && <FormHelperText>{error.message}</FormHelperText>}
              </StyledUiSelect>
            );
          }}
        />
      );
    return (
      <Select
        name={name}
        ref={ref}
        className={className}
        fullWidth
        MenuProps={{
          PaperProps: {
            sx: {
              padding: '0',
              direction: (theme) => theme.direction,
              '& .MuiList-root': {
                '& .MuiMenuItem-root': {
                  padding: '16px !important',
                  lineHeight: '20px !important',
                  fontFamily: 'inherit !important',
                  fontSize: '0.75rem !important',
                  '&:hover': {
                    color: '#222222 !important',
                    borderRadius: '6px !important',
                    textDecoration: 'none',
                    backgroundColor: '#aadbdd !important',
                  },
                },
              },
            },
          },
        }}
        {...rest}
      >
        {children}
      </Select>
    );
  }
);

UiSelect.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  name: PropTypes.string,
  control: PropTypes.object,
};

export default memo(UiSelect);
